import './assets/css/iconfont.scss';
import './assets/css/methods.scss';
import methods from './methods';

export default {
  install: function(Vue) {
    Vue.prototype.$hll = methods;
  },
  $hll: methods
};
